
import Vue from 'vue';
import Component from "vue-class-component";
import {BModal} from "bootstrap-vue";
import {Prop} from 'vue-property-decorator';
import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
import {PracticeListActions} from "@/api-client";
import {RawLocation} from "vue-router";

@Component({
    components: {
        CardQuicklink
    }
})
export default class AddPracticeModal extends Vue {
    @Prop({default: "ship-repair-practice-add"})
    shipRepairRouteName!: string;

    @Prop({default: "seafaring-practice-add"})
    seafaringRouteName!: string;

    @Prop({default: "inland-vessel-practice-add"})
    inlandVesselRouteName!: string;

    @Prop({default: "pilotage-practice-add"})
    pilotageRouteName!: string;

    @Prop({default: "vts-center-practice-add"})
    vtsCenterRouteName!: string;

    @Prop({required: true})
    actions!: PracticeListActions;

    seafarerId = "";

    $refs!: {
        modal: BModal;
    }

    get shipRepairUrl(): RawLocation {
        return {name: this.shipRepairRouteName, params: {seafarerId: this.seafarerId}};
    }

    get seafaringUrl(): RawLocation {
        return {name: this.seafaringRouteName, params: {seafarerId: this.seafarerId}};
    }

    get inlandVesselUrl(): RawLocation {
        return {name: this.inlandVesselRouteName, params: {seafarerId: this.seafarerId}};
    }

    get pilotageUrl(): RawLocation {
        return {name: this.pilotageRouteName, params: {seafarerId: this.seafarerId}};
    }

    get vtsCenterUrl(): RawLocation {
        return {name: this.vtsCenterRouteName, params: {seafarerId: this.seafarerId}};
    }

    public open(seafarerId: string) {
        this.seafarerId = seafarerId;
        this.$refs.modal.show();
    }
}
